<template>
<section class="pt-8 pt-md-5 pb-8 pb-md-14">
    <div class="container">
        <Spinner v-if="!loaded" />
        <div class="row" v-else>
            <div class="col-12">
                <h1 class="mb-0 fw-bold">Tokens</h1>
                <p class="mb-6 text-muted">
                    Create tokens and use to access your API<br>
                    <a :href="`${prefix}/docs`" v-if="$state.context.id">{{ prefix }}/docs</a> (Cloudflare, Swagger)<br>
                    <a :href="`${prefix}/redoc`" v-if="$state.context.id">{{ prefix }}/redoc</a> (Cloudflare, Redoc)<br>
                </p>
                <div class="table-responsive">
                    <vue-good-table
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="paginationOptions"
                        @page-change="onPageChange"
                    >
                        <template #table-row="props">
                            <span v-if="props.column.field === 'access_key'">
                                {{ props.row.access_key }}
                                <button class="btn-copy-inline" @click="copyKey(props.row.access_key)" title="Copy">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
                                    </svg>
                                </button>
                            </span>
                            <span v-else-if="props.column.field === 'actions'">
                                <button class="btn btn-primary mb-1 me-1 btn-xs" @click="edit(props.row)">Edit</button>
                                <button class="btn btn-danger mb-1 btn-xs" @click="remove(props.row)">Delete</button>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </template>
                    </vue-good-table>
                </div>
                <button class="btn btn-primary mb-1 btn-xs mt-3" @click="create" :disabled="disabled">Create a token</button>
                <div v-if="$state.context.id" class="mt-4">
                    <p class="mb-2">To use the API you need to pass "Access Key" in headers:</p>
                    <CodeCopy :code="codeHeaders" lang="sh" class="mb-4" />
                    <p class="mb-2">or as a GET-parameter:</p>
                    <CodeCopy :code="codeQuery" lang="bash" />
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import { toDateTime } from "utils/date";
import Spinner from "../Spinner.vue";
import CodeCopy from "../CodeCopy.vue";
import { highlightAll } from "../../js/highlight";
import tablePagination from "../../mixins/tablePagination"

export default {
    components: {
        Spinner,
        CodeCopy,
    },
    mixins: [tablePagination],
    data() {
        return {
            firstAccessKey: "<YOUR ACCESS KEY>",
            disabled: false,
            loaded: false,
            columns: [
                { label: "Name", field: "name", sortable: false },
                { label: "Access key", field: "access_key", sortable: false },
                { label: "Date of creation", field: "created_at", formatFn: toDateTime, sortable: false },
                { label: "Actions", field: "actions", sortable: false },
            ],
            rows: [],
            currentPage: 1,
        }
    },
    computed: {
        prefix() {
            return `https://api.${location.hostname}`
        },
        codeHeaders() {
            return `curl -X GET '${this.prefix}/v1/user/by/id?id=123123' \\
  -H 'accept: application/json' \\
  -H 'x-access-key: ${this.firstAccessKey}'`
        },
        codeQuery() {
            return `curl -X GET '${this.prefix}/v1/user/by/id?id=123123&access_key=${this.firstAccessKey}' \\
  -H 'accept: application/json'`
        },
    },
    methods: {
        fetch(data) {
            data = data || {}
            this.$services.Token().get(data).then(resp => {
                if (resp.body.data && resp.body.data[0])
                    this.firstAccessKey = resp.body.data[0].access_key
                this.rows = resp.body.data || [];
            }).finally(() => {
                this.loaded = true;
                this.$nextTick(highlightAll);
            })
        },
        create() {
            this.disabled = true
            this.$services.Token().save().then(resp => {
                this.fetch()
            }).finally(() => {
                this.disabled = false
            })
        },
        edit(data) {
            let name = prompt("Change name", data.name)
            if (name) {
                this.$services.Token().update({id: data.id, name}).then(resp => {
                    this.fetch()
                })
            }
        },
        remove(data) {
            if (!confirm("Are you sure?")) return
            this.$services.Token().delete({id: data.id}).then(resp => {
                this.fetch()
            })
        },
        onPageChange(params) {
            this.currentPage = params.currentPage;
            this.fetch({ page: params.currentPage });
        },
        copyKey(key) {
            this.$methods.copyToClipboard(key)
            this.$notify.success({ title: 'Copied', message: 'Access key copied' })
        }
    },
    created() {
        this.fetch()
    }
}
</script>
